/* eslint-disable no-console */
import { createAction, handleActions } from 'redux-actions'
import { push } from 'react-router-redux'

const NULLIFY_DEEP_ROUTE = 'NULLIFY_DEEP_ROUTE'

const initialState = {}

const nullifyDeepRoute = createAction(NULLIFY_DEEP_ROUTE)

export function handleDeepRoute() {
    return (dispatch, getState) => {
        let route = getState().deepRoute
        if (route) {
            dispatch(nullifyDeepRoute())
            dispatch(push(route))
        }
    }
}

export default handleActions({
  [NULLIFY_DEEP_ROUTE]: state => ({
    ...state,
    deepRoute: null
  })
}, initialState)
